var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultivaluedAttribute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 75,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000",
    ry: 33,
    rx: 119,
    id: "svg_11",
    cy: 37,
    cx: 122,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000",
    ry: 28,
    rx: 114,
    id: "svg_11",
    cy: 37,
    cx: 122,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Noto Sans JP",
    fontSize: 24,
    id: "svg_3",
    y: 44,
    x: 21,
    strokeWidth: 0,
    stroke: "#000",
    fill: "#000000"
  }, "Multivalued Attribute"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultivaluedAttribute);
export default __webpack_public_path__ + "static/media/MultivaluedAttribute.bd32b82fa6f5c8bfff53edc1387cf816.svg";
export { ForwardRef as ReactComponent };